import { ReactComponent as SvgLocation } from '@img/icons/location.svg';
import { ReactComponent as SvgChevron } from '@img/icons/nav-arrow-right.svg';
import { locations } from '@redux/slices/locations';
import { useAppDispatch, useAppSelector } from '@redux/store';
import PaginationSummary from '@stories/Components/PaginationSummary/PaginationSummary';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './ListArea.styles';
const ListItem = (props) => {
    return (React.createElement(S.Item, null,
        React.createElement(S.ItemCircle, null, props.index),
        React.createElement(S.ItemContent, null,
            React.createElement(S.ItemTitle, null, props.name),
            props.address && React.createElement(S.ItemAddress, null, props.address.slice(-2).join(', ')),
            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                React.createElement(S.ItemCta, { type: "button", onClick: (event) => {
                        event.preventDefault();
                        props.onSelect(props.id);
                    } },
                    "Show More",
                    React.createElement(SvgChevron, null)))),
        !!props.distance && (React.createElement(S.ItemDistance, null,
            React.createElement(S.ItemDistanceIcon, { as: SvgLocation }),
            props.distance,
            " miles"))));
};
const ListArea = () => {
    const dispatch = useAppDispatch();
    const state = useAppSelector((state) => state.locations);
    const items = state.apiData?.items ?? [];
    const totalCount = state.apiData?.totalCount ?? 0;
    return (React.createElement(S.Container, null,
        React.createElement(PaginationSummary, { of: totalCount }),
        items.length > 0 && (React.createElement(S.List, null, items.slice(0, 3).map((item, index) => (React.createElement(ListItem, { key: item.id, ...item, index: index + 1, onSelect: (id) => {
                dispatch(locations.actions.selectLocation(id));
            } })))))));
};
export default ListArea;
